var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1078_366)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 0C10.2878 0 6.72437 1.47591 4.10156 4.10047C1.47604 6.72607 0.000727278 10.2869 0 14C0 17.7115 1.47656 21.275 4.10156 23.8995C6.72437 26.5241 10.2878 28 14 28C17.7122 28 21.2756 26.5241 23.8984 23.8995C26.5234 21.275 28 17.7115 28 14C28 10.2885 26.5234 6.72503 23.8984 4.10047C21.2756 1.47591 17.7122 0 14 0Z",
    fill: "url(#paint0_linear_1078_366)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.33699 13.8521C10.4189 12.0741 13.1401 10.9018 14.5007 10.3354C18.3901 8.71821 19.1973 8.43733 19.7245 8.42782C19.8404 8.42596 20.0986 8.45461 20.267 8.59079C20.407 8.70563 20.4464 8.86094 20.4661 8.96999C20.4836 9.07893 20.5076 9.32721 20.4879 9.52102C20.2779 11.7348 19.3657 17.1068 18.902 19.5864C18.7073 20.6355 18.3201 20.9872 17.9461 21.0216C17.1323 21.0964 16.5154 20.4843 15.7279 19.9683C14.4964 19.1605 13.8007 18.6578 12.6042 17.8696C11.2217 16.9587 12.1186 16.458 12.9061 15.6399C13.1117 15.4257 16.6948 12.1675 16.7626 11.8719C16.7714 11.835 16.7801 11.6971 16.697 11.6245C16.6161 11.5517 16.4957 11.5766 16.4082 11.5963C16.2836 11.6243 14.317 12.9254 10.502 15.4995C9.94418 15.8831 9.43886 16.0702 8.98386 16.0603C8.48511 16.0496 7.52261 15.7777 6.8073 15.5454C5.9323 15.2604 5.23449 15.1096 5.29574 14.6256C5.32636 14.3736 5.67418 14.1156 6.33699 13.8521V13.8521Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1078_366",
    x1: 14,
    y1: 0,
    x2: 14,
    y2: 28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AABEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#229ED9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1078_366"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTel);
export default __webpack_public_path__ + "static/media/tel.e35206e4d8e69ff294af8b1082fdddad.svg";
export { ForwardRef as ReactComponent };